import React from "react";
import { Award, ShieldCheck } from "lucide-react";

/**
 * Trust badge showing "Consultora eXp Portugal" credentials.
 * Compact and light-glass style, sits gracefully next to Zelia's photo.
 */
export default function TrustBadge({ compact = false, className = "" }) {
  if (compact) {
    return (
      <div
        data-testid="trust-badge-compact"
        className={`inline-flex items-center gap-2 rounded-full border border-stone-200 bg-white/90 px-3 py-1.5 backdrop-blur ${className}`}
      >
        <ShieldCheck className="h-3.5 w-3.5 text-[#103C4A]" />
        <span className="text-[11px] uppercase tracking-widest text-stone-700">Consultora eXp Portugal</span>
      </div>
    );
  }

  return (
    <div
      data-testid="trust-badge"
      className={`inline-flex items-start gap-3 rounded-2xl border border-stone-200 bg-white/95 px-5 py-4 shadow-[0_10px_30px_rgba(16,60,74,0.08)] backdrop-blur ${className}`}
    >
      <div className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#103C4A] text-white">
        <Award className="h-4 w-4" />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500">Certificação</div>
        <div className="mt-0.5 font-medium text-stone-900 text-sm leading-tight">Consultora eXp Portugal</div>
        <div className="mt-0.5 text-xs text-stone-600">Mais de 10 anos · AMI regulada</div>
      </div>
    </div>
  );
}
